module.exports = __webpack_public_path__ + "img/talent.a7e7b18c.png";